import { PropsWithChildren, useEffect, useState } from 'react';
import cn from 'classnames';
import { createPortal } from 'react-dom';
import styles from './modal.module.scss';

const ID_ROOT_MODAL_ELEMENT = 'root-modal-element';

const ModalPortal = ({ children }: PropsWithChildren) => {
  const [rootElement, setRootElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const rootElement = document.getElementById(ID_ROOT_MODAL_ELEMENT);
    setRootElement(rootElement);
  }, []);
  return <>{rootElement && createPortal(children, rootElement)}</>;
};

export type ConstructionModalProps = PropsWithChildren & {
  className?: string;
  backgroundClassName?: string;
  onClose?: () => void;
};
export const ConstructionModal = ({ className, backgroundClassName, children, onClose }: ConstructionModalProps) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <ModalPortal>
      <div className={cn(styles.background, backgroundClassName)} onClick={onClose}>
        <div className={cn(styles.constructionModal, className)}>{children}</div>
      </div>
    </ModalPortal>
  );
};
